(function ($) {
  Drupal.behaviors.hotspotTextV2 = {
    isRTL: site.direction.isRTL,
    translations: {
      vtoCtaText: site.translations.product.vto_cta_text
    },
    attach: function (context) {
      var self = this;
      var $hotspots = $('.js-hotspot-text-field-v2', context);

      $hotspots.each(function () {
        var $this = $(this);

        self.getDom($this);
        self.getSettings($this);
        self.setup($this, $this.nodes.$container);
      });
      self.setGlobalEvents();
    },

    getDom: function ($that) {
      $that.nodes = {};
      $that.nodes.$container = $that.parent();
    },

    getSettings: function ($that) {
      $that.settings = {};
      $that.settings.highlightedText = $that.data('textToHighlight');
      $that.settings.highlightBgColor = $that.data('highlightBgColor');
      $that.settings.highlightHoverBgColor = $that.data('highlightHoverBgColor');
      $that.settings.highlightColor = $that.data('highlightColor');
      $that.settings.highlightSize = $that.data('highlightSize');
      $that.settings.highlightCheck = $that.data('highlightCheck');
      $that.settings.highlightPaddings = $that.data('highlightPaddings');
      $that.settings.highlightCurved = $that.data('highlightCurved');
      $that.settings.highlightUnderline = $that.data('highlightUnderline');
      $that.settings.highlightOperation = $that.data('highlightOperation');
      $that.settings.highlightAnchors = $that.data('highlightAnchors');
      $that.settings.hotspotProducts = $that.data('hotspotProducts');
      $that.settings.hotspotSku = $that.data('hotspotSku');
      $that.settings.highlightLink = $that.data('highlightLink');
      $that.settings.hotspotAddToBagLabel = $that.data('hotspotAddToBagLabel');
    },
    setGlobalEvents: function () {
      var self = this;
      $(document).on(
        'hotspot.enable',
        '.js-trending-looks-block-formatter--v1',
        function (e, highlightedTextData, $item) {
          self.parseData($item, highlightedTextData);
          self.getDom($item);
          self.setup($item);
        }
      );
    },

    setup: function ($that) {
      var self = this;
      var i;
      let attrObj = {};
      var highlightedText = $that.settings.highlightedText.split(', ');

      $that.nodes.$highlightedTextItem = $();
      self.loopHighlightedText($that, highlightedText);

      if ($that.nodes.$highlightedTextItem && $that.nodes.$highlightedTextItem.length > 0) {
        $that.nodes.$highlightedTextItem.each(function () {
          var $this = $(this);

          typeof $this.attr('data-text-highlight') === 'undefined' ? $this.attr('data-text-highlight', highlightedText[0]) : null;

          // Gathering CMS data.
          for (i = 0; i < $this[0].attributes.length; i++) {
            if ($this[0].attributes[i].nodeName !== 'class') {
              attrObj[$this[0].attributes[i].nodeName] =
                $this[0].attributes[i].nodeValue;
            }
          }

          $this.find('.js-hotspot-text__highlight').length === 0 ? self.updateTextHighlight($this, attrObj) : null;
          let $itemFooter = $this
            .closest('.js-trending-looks-item-article-trigger')
            .find('.trending-looks-item-article-trigger__footer');

          // if there's no hotspot product, remove footer and add specific class to highlighted text for further specific styling
          if ($this.find('.js-product-select').length === 0) {
            $this.addClass('no-product');
          } else {
            $itemFooter.length > 0 ? $itemFooter.addClass('hidden') : null;
          }
        });
      }
    },

    loopHighlightedText: function ($that, highlightedText) {
      var self = this;
      var $repl = $('<span />').addClass('hotspot-text js-hotspot-text');
      var $tmpItem = $();
      let updatedItemHtml = '';
      // If we don't have the first text, go 1 parent up.
      var $item = $that.text().indexOf(highlightedText[0]) !== -1 ? $that : $that.nodes.$container;

      self.setAttributes($repl, $that);

      for (var i = 0; i < highlightedText.length; i++) {
        $repl.text(highlightedText[i]);

        $tmpItem = $item.children().filter(function () {
          return $(this).text().indexOf(highlightedText[i]) !== -1;
        });

        $tmpItem = $tmpItem.length > 0 ? $tmpItem : $item;
        if ($tmpItem.length < 1) {
          continue;
        }
        updatedItemHtml = $tmpItem.html().replace(highlightedText[i], $repl[0].outerHTML);
        $tmpItem.html(updatedItemHtml);

        $that.nodes.$highlightedTextItem = $tmpItem.find('.js-hotspot-text');

        if ($that.nodes.$highlightedTextItem.length === 1) {
          $($that.nodes.$highlightedTextItem[i]).attr('data-text-highlight', highlightedText[i]);
        }
        $that.nodes.$highlightedTextItem.each(function () {
          $(this).data('parentNode', $tmpItem);
          $tmpItem.addClass('js-parent-for-' + $(this).data('productId'));
        });
      }
    },

    parseData: function ($item, data) {
      var highlightedTextData = data.text_highlighting.component_group.component_group.component_group_display;

      $item.settings = {
        highlightedText: highlightedTextData.text_to_highlight.textfield,
        highlightBgColor: highlightedTextData.text_to_highlight_bgcolor.hex,
        highlightHoverBgColor: highlightedTextData.text_to_highlight_hover_bgcolor.hex,
        highlightColor: highlightedTextData.text_to_highlight_color.hex,
        highlightSize: highlightedTextData.text_to_highlight_size.select,
        highlightCheck: highlightedTextData.text_to_highlight_check.checkbox,
        highlightPaddings: highlightedTextData.text_to_highlight_paddings.textfield,
        highlightCurved: highlightedTextData.text_to_highlight_curved.checkbox,
        highlightUnderline: highlightedTextData.text_to_highlight_underline
          ? highlightedTextData.text_to_highlight_underline.checkbox
          : false,

        highlightOperation: highlightedTextData.text_to_highlight_operation.select,
        highlightAnchors: highlightedTextData.text_to_highlight_anchors.textfield,
        hotspotProducts: highlightedTextData.text_to_highlight_products,
        hotspotSku: highlightedTextData.text_to_highlight_sku?.textfield,
        highlightLink: highlightedTextData.text_to_highlight_link ? highlightedTextData.text_to_highlight_link.link.url : '',
        hotspotAddToBagLabel: highlightedTextData.text_to_highlight_atb_label.textfield,
        showVTO: data.show_vto ? data.show_vto.checkbox.value : null,
        looksGUID: data.looks_guid ? data.looks_guid.textfield : null,
        showIcons: data.show_icons ? data.show_icons.checkbox.value : null,
        enableClickableProdName: data.clickable_prod_name ? data.clickable_prod_name.checkbox.value : null
      };
    },

    setAttributes($highlightedTextItem, $that) {
      let highlightBgColor = $that.settings.highlightBgColor;
      let highlightHoverBgColor = $that.settings.highlightHoverBgColor;
      let highlightColor = $that.settings.highlightColor;
      let highlightSize = $that.settings.highlightSize;
      let highlightCheck = $that.settings.highlightCheck;
      let highlightPaddings = $that.settings.highlightPaddings;
      let highlightCurved = $that.settings.highlightCurved;
      let highlightUnderline = $that.settings.highlightUnderline;
      let highlightOperation = $that.settings.highlightOperation;
      let highlightAnchors = $that.settings.highlightAnchors;
      let hotspotProducts = $that.settings.hotspotProducts;
      let hotspotSku = $that.settings.hotspotSku;
      let highlightLink = $that.settings.highlightLink;
      let hotspotAddToBagLabel = $that.settings.hotspotAddToBagLabel;
      let showVTO = $that.settings.showVTO;
      let looksGUID = $that.settings.looksGUID;
      let showIcons = $that.settings.showIcons;
      let enableClickableProdName = $that.settings.enableClickableProdName;

      highlightBgColor
        ? $highlightedTextItem.attr(
          'data-text-highlight-bgcolor',
          '#' + highlightBgColor.replace('#', '')
        )
        : null;
      highlightHoverBgColor
        ? $highlightedTextItem.attr(
          'data-text-highlight-hover-bgcolor',
          '#' + highlightHoverBgColor.replace('#', '')
        )
        : null;
      highlightColor
        ? $highlightedTextItem.attr(
          'data-text-highlight-color',
          '#' + highlightColor.replace('#', '')
        )
        : null;
      highlightSize ? $highlightedTextItem.attr('data-text-highlight-size', highlightSize) : null;
      highlightCheck
        ? $highlightedTextItem.attr('data-text-highlight-check', highlightCheck)
        : null;
      highlightPaddings
        ? $highlightedTextItem.attr('data-text-highlight-paddings', highlightPaddings)
        : null;
      highlightCurved
        ? $highlightedTextItem.attr('data-text-highlight-curved', 'highlight-curved')
        : null;
      highlightUnderline
        ? $highlightedTextItem.attr('data-text-highlight-underline', 'highlight-underline')
        : null;
      highlightOperation
        ? $highlightedTextItem.attr('data-text-highlight-operation', highlightOperation)
        : null;
      highlightAnchors
        ? $highlightedTextItem.attr('data-text-highlight-anchors', highlightAnchors)
        : null;
      hotspotProducts
        ? $highlightedTextItem.attr('data-text-highlight-products', JSON.stringify(hotspotProducts))
        : null;
      hotspotSku
        ? $highlightedTextItem.attr('data-sku-base-id', hotspotSku)
        : null;
      highlightLink
        ? $highlightedTextItem.attr('data-text-highlight-link-url', highlightLink)
        : null;
      hotspotAddToBagLabel
        ? $highlightedTextItem.attr('data-text-highlight-atb-label', hotspotAddToBagLabel)
        : null;
      showVTO
        ? $highlightedTextItem.attr('data-show-vto', showVTO)
        : null;
      looksGUID
        ? $highlightedTextItem.attr('data-vto-guid', looksGUID)
        : null;
      showIcons
        ? $highlightedTextItem.attr('data-show-icons', showIcons)
        : null;
      enableClickableProdName
        ? $highlightedTextItem.attr('data-enable-clickable', enableClickableProdName)
        : null;
      hotspotProducts
        ? $highlightedTextItem.attr('data-product-id', hotspotProducts.product_id.product_id)
        : null;
    },
    updateTextHighlight($el, attrObj) {
      var self = this;
      var highlights;
      var anchors;
      var $highlightEls;

      if (attrObj['data-text-highlight']) {
        highlights = attrObj['data-text-highlight'];
        if (attrObj['data-text-highlight-anchors']) {
          anchors = attrObj['data-text-highlight-anchors'].split(',');
        }
        self.generateHighlights($el, highlights, attrObj);
        $highlightEls = $el.find('.js-hotspot-text__highlight');
        $highlightEls.length > 0
          ? self.setHighlightAttrs($highlightEls, anchors, attrObj)
          : self.setHighlightAttrs($el, anchors, attrObj);
      }
    },
    generateHighlights($el, highlights, attrObj) {
      var self = this;
      var curved = attrObj['data-text-highlight-curved'] || '';
      var underline = attrObj['data-text-highlight-underline'] || '';
      var cssClass = ['hotspot-text__highlight js-hotspot-text__highlight', curved, underline].join(
        ' '
      );
      var icon;
      var action;
      var $innerHTML = $();

      if (attrObj['data-text-highlight-operation']) {
        if (attrObj['data-text-highlight-operation'] === 'js-product') {
          icon = attrObj['data-show-icons']
            ? '<span class="hotspot-text__highlight-icon js-hotspot-text__highlight-icon"></span>'
            : '';
          action = '<span class="product-select js-product-select">' + highlights + '</span>';
        } else {
          action = '<a>' + highlights + '</a>';
          icon = '';
        }
        $innerHTML = $('<span class="has-action ' + cssClass + '">' + action + icon + '</span>');
        $el.html($innerHTML);
        attrObj['data-show-icons'] ? $el.find('.hotspot-text__highlight').addClass('show-icons') : null;
        if (!!attrObj['data-text-highlight-products']) {
          self.renderProduct($el, attrObj);
        }
      } else {
        $el.addClass(cssClass);
      }
    },
    renderProduct($el, attrObj) {
      var self = this;

      if ($el.find('.js-hotspot-text__product-wrapper').length > 0) {
        return;
      }
      var products = JSON.parse(attrObj['data-text-highlight-products']);
      let skuId = attrObj['data-sku-base-id'] ? [`SKU${attrObj['data-sku-base-id']}`] : null;

      products = products.product_id.product_id;
      products ? (products = products.split(',')) : null;

      var itemInlineTemplatePath = 'hotspot_text_fields_v2';
      var $inlineTemplate = $(
        'script.inline-template[path="' + itemInlineTemplatePath + '"]'
      ).html();

      generic.jsonrpc.fetch({
        method: 'prodcat',
        params: [
          {
            products: products,
            skus: skuId,
            product_fields: [
              'PRODUCT_ID',
              'AVERAGE_RATING',
              'PROD_RGN_NAME',
              'TOTAL_REVIEW_COUNT',
              'SHORT_DESC',
              'SMALL_IMAGE',
              'url',
              'shaded',
              'skus'
            ],
            sku_fields: [
              'formattedPrice',
              'SMALL_IMAGE',
              'IMAGE_MEDIUM',
              'SKU_ID',
              'SKU_BASE_ID',
              'SHADENAME',
              'VTO_FLAG_ONLINE',
              'VTO_FOUNDATION_ONLINE',
              'isShoppable'
            ]
          }
        ],
        onSuccess: function (jsonRpcResponse) {
          var result = jsonRpcResponse.getValue();
          var productHTML;
          var processedShadename;
          var shadeRoute;
          var productId = result.products[0].PRODUCT_ID;
          var $parentNode = $el.data('parentNode') || $('.js-parent-for-' + $el.data('productId'));

          $el = $parentNode.find('.js-hotspot-text[data-product-id="' + productId + '"]') || $el;
          $el
            .find('.js-hotspot-text__highlight')
            .append(
              '<span class="hotspot-text__product-wrapper js-hotspot-text__product-wrapper"></span>'
            );
          var $productWrapper = $el.find('.js-hotspot-text__product-wrapper');

          $productWrapper.append($('<span class="hotspot-text__product-chevron"></span>'));
          self.setProductListener($productWrapper.closest('.js-hotspot-text__highlight'));
          for (var i = 0; i < result.products.length; i++) {
            let displayProduct = result.skus ? result.skus[0] : result.products[0].skus[0];

            if (result.skus) {
              result.products[0].skus.unshift(result.skus[0]);
            }

            processedShadename = displayProduct.SHADENAME ? displayProduct.SHADENAME.replace(/\s/g, '_') : null;
            if (!!processedShadename) {
              shadeRoute = self.buildShadeRoute(processedShadename);
              result.products[0]['shade_route'] = shadeRoute;
            }
            result.products[0]['show_vto'] = attrObj['data-show-vto'];
            result.products[0]['clickable_prod_name'] = attrObj['data-enable-clickable'];
            productHTML = Mustache.render($inlineTemplate, result);
            $productWrapper.html(productHTML);
          }
          $productWrapper.append($('<span class="hotspot-text__product-chevron"></span>'));
          self.translations.vtoCtaText ? $el.find('.js-hotspot-vto-btn').html(self.translations.vtoCtaText) : null;
          attrObj['data-vto-guid']
            ? $productWrapper
              .find('.js-hotspot-text__product-cta-wrapper')
              .addClass('js-looks-destination-overlay-v1')
              .attr('data-looks-guid', attrObj['data-vto-guid'])
            : null;
          self.displayATB($el, attrObj);
          attrObj['data-show-vto'] ? self.vtoLooks($productWrapper) : null;
          self.calculateReviewWidth($productWrapper.find('.js-hotspot-text__product'));
          prodcat.data.updateProducts(result.products);
        },
        onFailure: function (error) {
          console.error('Error in JSON RPC call:', error);
        }
      });
    },
    characterEncode(str) {
      return encodeURIComponent(str).replace(
        /[!'()*]/g,
        function (c) {
          return '%' + c.charCodeAt(0).toString(16);
        }
      );
    },
    vtoLooks($productWrapper) {
      // Youcam overlay enabled
      var $hotspotVtoButton = $('.js-hotspot-vto-btn', $productWrapper);
      var $ymkModuleContent = $('#YMK-module');

      $hotspotVtoButton.once().on('click', function (e) {
        return; // Temporarily disabling vto functionality
        e.preventDefault();
        window.YMK.open();
        $ymkModuleContent.removeClass('hidden');
        $('body').addClass('vto-overlay-launched');
        $productWrapper.find('.js-hotspot-text__product').css({
          width: $ymkModuleContent.width(),
          height: $ymkModuleContent.height()
        });
        $(document).trigger('openVtoModule');
      });
    },
    buildShadeRoute(shadeName) {
      var self = this;
      var shadeNameNoSpaces = self.characterEncode(shadeName);

      return '?shade=' + shadeNameNoSpaces;
    },
    calculateReviewWidth($productPanel) {
      var reviewWidth = 0;
      var rating = Number($productPanel.data('rating'));

      if (rating) {
        reviewWidth = (rating / 5) * 100;
      }
      $productPanel
        .find('.js-hotspot-text__reviews-stars-simplified-stars')
        .css('width', reviewWidth + '%');
    },
    setProductListener($highlight) {
      $highlight.off('click.product').on('click.product', function () {
        $(this).toggleClass('hover-click');
      });
    },
    setHighlightAttrs($highlightEls, anchors, attrObj) {
      var self = this;

      $highlightEls.each(function (index) {
        var $highlightEl = $(this);

        self.setBackgroundColor($highlightEl, attrObj);
        self.setHighlightListeners($highlightEl, attrObj);
        self.setTextColor($highlightEl, attrObj);
        self.setTextUnderline($highlightEl, attrObj);
        self.setHighligtSize($highlightEl, attrObj);
        self.setHighlightPadding($highlightEl, attrObj);
        self.setHighlightOperation($highlightEl, anchors, index, attrObj);
      });
    },
    setTextColor($element, attrObj) {
      if (attrObj['data-text-highlight-color']) {
        $element.css('color', attrObj['data-text-highlight-color']);
      }
    },
    setHighligtSize($element, attrObj) {
      if (attrObj['data-text-highlight-size']) {
        $element.css('font-size', attrObj['data-text-highlight-size']);
      }
    },
    setTextUnderline($element, attrObj) {
      let color = attrObj['data-text-highlight-color'] || '#000';

      if (attrObj['data-text-highlight-underline']) {
        $element.css('border-bottom', '1px solid ' + color);
      }
    },
    setHighlightPadding($element, attrObj) {
      if (attrObj['data-text-highlight-paddings']) {
        $element.css('padding', attrObj['data-text-highlight-paddings']);
      }
    },
    displayATB($element, attrObj) {
      if (attrObj['data-text-highlight-atb-label']) {
        $element.find('.js-hotspot-text__product-atb').removeClass('hidden');
        $element.find('.js-product-add-to-bag').html(attrObj['data-text-highlight-atb-label']);
      }
    },
    setHighlightOperation($element, anchors, index, attrObj) {
      if (
        attrObj['data-text-highlight-operation'] &&
        attrObj['data-text-highlight-operation'] === 'js-anchor' &&
        anchors
      ) {
        $element.find('a').attr('href', '#' + anchors[index]);
      } else if (
        attrObj['data-text-highlight-operation'] &&
        attrObj['data-text-highlight-link-url'] &&
        attrObj['data-text-highlight-operation'] === 'js-link'
      ) {
        $element.find('a').attr('href', attrObj['data-text-highlight-link-url']);
      }
    },
    setBackgroundColor($element, attrObj) {
      var bgColor;

      if (attrObj['data-text-highlight-bgcolor']) {
        bgColor = attrObj['data-text-highlight-bgcolor'];
        if (attrObj['data-text-highlight-curved'] === '') {
          if (attrObj['data-text-highlight-check']) {
            $element.find('span').css('background-color', bgColor);
          } else {
            attrObj['data-text-highlight-check']
              ? $element.find('span').css('background-color', bgColor)
              : $element.find('div').css('background-color', bgColor);
          }
          if ($element.find('a').length > 0) {
            $element.find('a').css('color', bgColor);
          }
        } else {
          $element.css('background-color', bgColor);
        }
      }
    },
    setHighlightListeners($element, attrObj) {
      var colorWhite = '#FFFFFF';

      if (attrObj['data-text-highlight-hover-bgcolor']) {
        $element.mouseover(function () {
          $(this).css('background-color', attrObj['data-text-highlight-hover-bgcolor']);
        });
        $element.mouseout(function () {
          $(this).css('background-color', attrObj['data-text-highlight-bgcolor'] || colorWhite);
        });
      }
    }
  };
})(jQuery);
